import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Col,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState, } from 'recoil';
import Table from "../../components/react-table/Table";
import { useUser } from "../../context/user";
import { GET, POST } from "../../helper/api";
import { popupCustomerFlowAtom, popupExchangeBetweenBankAccountAtom, popupTransactionHistoryAtom } from '../../state';
import { REPORT_ASSIGN_CONFIRM_TYPE, REPORT_ASSIGN_CONFIRM_TYPE_OPTIONS, SETTING_KEY } from "../../utils/Utils";
import RangeDatePicker from "../../components/range-date-picker/RangeDatePicker";



const DEFAULT_WAITING_REVIEW = {
  reviewerIds: []
}

const ReportApprovedTransactionHistory = () => {

  const {
    state: { user },
  } = useUser();
  const { role } = user || {};

  const {
    errors,
    handleSubmit,
    getValues,
    control,
  } = useForm({
    defaultValues: {
      ...DEFAULT_WAITING_REVIEW
    },
  });

  const printRef = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [popupTransactionHistory] = useRecoilState(popupTransactionHistoryAtom);
  const [popupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);
  const [popupExchangeBetweenBankAccount] = useRecoilState(popupExchangeBetweenBankAccountAtom);
  const [timeNow, setTimeNow] = useState();
  const [userOptions, setUserOptions] = useState([]);
  const [listDayNotYetRequestReview, setListDayNotYetRequestReview] = useState([]);
  const [needApproveByUser, setNeedApproveByUser] = useState([]);
  const [reviewerNotConfirms, setReviewerNotConfirms] = useState([]);

  const history = useHistory();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    addReport: false,
    agreeReport: false,
    cancelReport: false,
  });


  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});

  const [filter, setFilter] = useState({
    confirmType: searchParams.get("confirmType") || REPORT_ASSIGN_CONFIRM_TYPE.NOT_APPROVED,

  });

  const [rangeDate, setRangeDate] = useState({
    startDate: moment(searchParams.get("startDate") || undefined).startOf('days').toDate(),
    endDate: moment(searchParams.get("endDate") || undefined).endOf('days').toDate(),
  });


  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  }

  const colTable = [
    {
      Header: "Mã",
      accessor: (item) => item?.id,
    },
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },

    {
      Header: "KH/NCC",
      accessor: (item) => item?.customer?.name
    },
    {
      Header: "Nội dung",
      accessor: (item) => item?.content || "",
    },
    {
      Header: "Danh mục",
      accessor: (item) => item?.category?.name || "",
    },
    {
      Header: "Quỹ tài khoản",
      accessor: (item) => item?.bankAccount?.name || "",
    },
    {
      Header: "Tiền thu(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền chi(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Người nhận",
      accessor: (item) => item?.receiver || "",
    },
    {
      Header: "Hợp đồng",
      accessor: (item) => item?.contractId || "",
    },
  ];


  const exportExcel = () => {
    const params = new URLSearchParams({
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
      ...(filter.confirmType ? { confirmType: filter.confirmType } : {}),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/transaction-history/report-by-day-excel?${params.toString()}`;
    window.open(url, '_blank')
  };


  useEffect(() => {
    GET(`/user/list-can-confirm-assign-review/${SETTING_KEY.ASSIGN_REVIEWER_TRANSACTION_HISTORY}`, {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });
  }, []);
  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
      ...(filter.confirmType ? { confirmType: filter.confirmType } : {}),

    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
      ...(filter.confirmType ? { confirmType: filter.confirmType } : {}),
    };
    GET(`/transaction-history/report-by-day`, params, true)
      .then(({ data: { data, summary, listDayNotYetRequestReview, needApproveByUser, reviewerNotConfirms } }) => {
        setData(data)
        setSummary(summary)
        setListDayNotYetRequestReview(listDayNotYetRequestReview.map(e => moment(e, 'YYYY-MM-DD').format('DD')))
        setNeedApproveByUser(needApproveByUser.map(e => moment(e, 'YYYY-MM-DD').format('DD-MM-YYYY')))
        setReviewerNotConfirms(reviewerNotConfirms);

      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter, timeNow, popupTransactionHistory.updatedAt, popupCustomerFlow.updatedAt, popupExchangeBetweenBankAccount.updatedAt]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ addReport: false, agreeReport: false, cancelReport: false });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };


  const cancelReportAssignReport = () => {
    let payload = {
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
    };
    POST(`/transaction-history/cancel-report-assign`, payload, {}, true)
      .then((res) => {
        toast.success("Huỷ yêu cầu duyệt báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const addReportWaitingApprovedTransaction = () => {
    const { reviewerIds } = getValues();
    let params = {
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
      reviewerIds
    };
    POST(`/transaction-history/add-report-assign`, {}, params, true)
      .then((res) => {
        toast.success("Gửi yê cầu duyệt báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };


  const actionReportAssign = (confirmType) => {

    POST(`/transaction-history/action-request-assign`, {
      confirmType,
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD')
    }, {}, true)
      .then((res) => {
        toast.success("Duyệt báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };


  const maxRangeDate = useMemo(() => {
    if (!rangeDate.startDate) return null;
    const endOfMonth = moment(rangeDate.startDate).endOf('month').toDate();
    if (moment().isBefore(endOfMonth)) {
      return moment().toDate();
    }
    return endOfMonth;
  }, [rangeDate.startDate]);

  return (
    <React.Fragment>
      <Head title="Quản lý giao dịch"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <RangeDatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={maxRangeDate}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap">
                        <RSelect
                          isClearable
                          placeholder={"Lọc tình trạng duyệt"}
                          options={REPORT_ASSIGN_CONFIRM_TYPE_OPTIONS}
                          value={REPORT_ASSIGN_CONFIRM_TYPE_OPTIONS.find((c) => c.value === filter.confirmType) || null}
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              confirmType: val?.value || undefined,
                            });
                          }}
                        />
                      </div>
                    </li>
                    {userOptions.map(e => e.value).includes(user.id) ?
                      <li>
                        <div>
                          <Button
                            color="secondary"
                            onClick={() => {
                              toggle('agreeReport')
                            }}
                          >
                            <span>Duyệt báo cáo</span>
                          </Button>
                        </div>
                      </li>
                      : <>
                        <li>
                          <div>
                            <Button
                              color="secondary"
                              onClick={() => {
                                toggle('addReport')
                              }}
                            >
                              <span>Gửi báo cáo</span>
                            </Button>
                          </div>
                        </li>
                        <li className="">
                          <div className="">
                            <Button
                              className=""
                              color="warning"
                              onClick={() => {
                                toggle('cancelReport')
                              }}
                            >
                              <span>Huỷ yêu cầu duyệt báo cáo</span>
                            </Button>
                          </div>
                        </li>
                      </>}

                    <li className="">
                      <div className="">
                        <Button
                          className=""
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div>
                  <h6>Ngày chưa gửi báo cáo trong tháng: <span className="font-weight-normal">{listDayNotYetRequestReview?.join(', ')}</span></h6>
                  <h6>Ngày tôi chưa duyệt: <span className="font-weight-normal">{needApproveByUser?.join(', ')}</span></h6>
                  <h6>DS người chưa duyệt: <span className="font-weight-normal" style={{
                    whiteSpace: 'pre-line',
                  }}>{`\n`}{reviewerNotConfirms.map(e => `${e.name}: ${e.dates.map(d => moment(d, 'YYYY-MM-DD').format('DD-MM-YYYY')).join(', ')}`).join('\n')}</span></h6>
                </div>
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center">BÁO CÁO CHI TIẾT THU CHI</h5>
                  <h6 className="text-center">Từ ngày {moment(rangeDate.startDate).format('DD-MM-YYYY')} đến {moment(rangeDate.endDate).format('DD-MM-YYYY')}</h6>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={<tr className="nk-tb-item odd font-weight-bold">
                      <td colSpan={6} className="nk-tb-col">
                        <span> Tổng cộng: ({data.length || 0} đơn) ( <NumericFormat
                          displayType={"text"}
                          value={summary?.totalAmount}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />)</span>
                      </td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.totalAmountIn}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col text-right" >
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.totalAmountOut}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col">
                      </td>
                      <td className="nk-tb-col">
                      </td>
                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
        <Modal isOpen={view.addReport} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn gửi duyệt báo cáo từ ngày {moment(rangeDate.startDate).format('DD/MM/YYYY')} đến {moment(rangeDate.endDate).format('DD/MM/YYYY')} không?

              </h4>
              <form className="text-left" onSubmit={handleSubmit(addReportWaitingApprovedTransaction)}>
                <Row>
                  <Col md="12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Người duyệt
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="reviewerIds"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              isMulti
                              classNamePrefix="form-control"
                              inputRef={ref}
                              name={name}
                              options={userOptions}
                              value={userOptions.filter(
                                (c) => {
                                  return value?.includes(c.value)
                                }
                              )}
                              onChange={(val) => {
                                onChange(val.map(e => e.value) || [])
                              }}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="reviewerIds"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <div className="nk-modal-action mt-5 d-flex justify-content-around">
                  <Button
                    type={'button'}
                    color="light"
                    size="lg"
                    className="btn-mw mr-5"
                    onClick={() => onFormCancel()}
                  >
                    Huỷ bỏ
                  </Button>
                  <Button
                    color="primary"
                    size="lg"
                    className="btn-mw"
                  >
                    Xác nhận
                  </Button>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.agreeReport} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
              <h4 className="nk-modal-title">
                Duyệt báo cáo từ ngày {moment(rangeDate.startDate).format('DD/MM/YYYY')} đến {moment(rangeDate.endDate).format('DD/MM/YYYY')} không?

              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  type={'button'}
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={() => actionReportAssign(REPORT_ASSIGN_CONFIRM_TYPE.APPROVED)}
                >
                  Duyệt
                </Button>

                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={() => actionReportAssign(REPORT_ASSIGN_CONFIRM_TYPE.NOT_APPROVED)}
                >
                  Từ chối
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.cancelReport} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn huỷ yêu cầu duyệt báo cáo từ ngày {moment(rangeDate.startDate).format('DD/MM/YYYY')} đến {moment(rangeDate.endDate).format('DD/MM/YYYY')} không?

              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  type={'button'}
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={() => cancelReportAssignReport()}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default ReportApprovedTransactionHistory;
